if ( typeof ProductBundler !== 'function' ) {

  class ProductBundler extends HTMLElement {

    constructor() {

      super();

      if ( this.querySelector('css-slider') ) {
        this.querySelector('css-slider').addEventListener('ready', ()=>{
          this.init();
        })
      } else {
        this.init();
      }

    }

    init(){

      this.bundleProducts = [...this.querySelectorAll('[data-js-bundler-product]')];
      this._bundleTemplate = this.querySelector('[data-js-bundler-product]').cloneNode(true);
      this._bundleMin = parseInt(this.dataset.minimum);

      this._getGiftBoxNumber = () => {
        return parseInt(localStorage.getItem('giftBoxCounter') || '1');
      };
      this._incrementGiftBoxNumber = () => {
        const next = this._getGiftBoxNumber() + 1;
        localStorage.setItem('giftBoxCounter', next);
      };
      this._updateBundlerTitle = () => {
        const titleEl = this.querySelector('#bundler-title');
        if (titleEl) titleEl.textContent = `Gift Box ${this._getGiftBoxNumber()}`;
      };

      // Shared helper: scan cart items, find highest Gift Box number, set counter to next
      this._syncCounterFromCart = (cart) => {
        if (cart.item_count === 0) {
          localStorage.setItem('giftBoxCounter', '1');
        } else {
          let highestBox = 0;
          cart.items.forEach(item => {
            const bundleProp = item.properties && item.properties['Bundle'];
            if (bundleProp) {
              const match = bundleProp.match(/Gift Box (\d+)/i);
              if (match) {
                const num = parseInt(match[1]);
                if (num > highestBox) highestBox = num;
              }
            }
          });
          localStorage.setItem('giftBoxCounter', highestBox > 0 ? highestBox + 1 : '1');
        }
        this._updateBundlerTitle();
      };

      // On page load: update title INSTANTLY from localStorage (zero delay)
      // then fetch cart in background to correct the counter
      this._updateBundlerTitle();
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => { this._syncCounterFromCart(cart); })
        .catch(() => {});

      this.querySelectorAll('[data-js-product-add-to-cart]').forEach(elm => {
        elm.addEventListener('click', e => {
          e.preventDefault();
          const product = e.target.closest('[data-js-product-item]');
          const tag = product.dataset.tags || '';
          const currentProducts = this.querySelectorAll('[data-js-bundler-product]:not(.bundler-product--empty)');
          const bundlePopup = document.querySelector('product-bundler .bundle_popup');
          const hasFreezer = Array.from(currentProducts).some(item =>
            item.dataset.tag === 'bundle-freezer-bag'
          );
          const hasMat = Array.from(currentProducts).some(item =>
            item.dataset.tag === 'bundle-mat'
          );
          const hasTowel = Array.from(currentProducts).some(item =>
            item.dataset.tag === 'bundle-double-towels'
          );
          if (currentProducts.length >= 4) {
            if (bundlePopup) {
              bundlePopup.innerHTML = `
                <span>Your box is now full</span>
                <button class="bundle-popup-close" aria-label="Close">&times;</button>
              `;
              bundlePopup.classList.add('active');
              const timeout = setTimeout(() => {
                bundlePopup.classList.remove('active');
              }, 5000);
              const closeBtn = bundlePopup.querySelector('.bundle-popup-close');
              closeBtn.addEventListener('click', () => {
                bundlePopup.classList.remove('active');
                clearTimeout(timeout);
              });
              const handleOutsideClick = (e) => {
                if (!bundlePopup.contains(e.target)) {
                  bundlePopup.classList.remove('active');
                  clearTimeout(timeout);
                  document.removeEventListener('click', handleOutsideClick);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleOutsideClick);
              }, 0);
            }
            return;
          }
          if (tag === 'bundle-freezer-bag' && hasFreezer) {
            if (bundlePopup) {
              bundlePopup.innerHTML = `
                <span>Only one freezer bag allowed</span>
                <button class="bundle-popup-close" aria-label="Close">&times;</button>
              `;
              bundlePopup.classList.add('active');
              const timeout = setTimeout(() => {
                bundlePopup.classList.remove('active');
              }, 5000);
              const closeBtn = bundlePopup.querySelector('.bundle-popup-close');
              closeBtn.addEventListener('click', () => {
                bundlePopup.classList.remove('active');
                clearTimeout(timeout);
              });
              const handleOutsideClick = (e) => {
                if (!bundlePopup.contains(e.target)) {
                  bundlePopup.classList.remove('active');
                  clearTimeout(timeout);
                  document.removeEventListener('click', handleOutsideClick);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleOutsideClick);
              }, 0);
            }
            return;
          }
          if (
            (hasFreezer && tag === 'bundle-mat') ||
            (tag === 'bundle-freezer-bag' && hasMat)
          ) {
            if (bundlePopup) {
              bundlePopup.innerHTML = `
                <span>Mat cannot be added with a freezer bag</span>
                <button class="bundle-popup-close" aria-label="Close">&times;</button>
              `;
              bundlePopup.classList.add('active');
              const timeout = setTimeout(() => {
                bundlePopup.classList.remove('active');
              }, 5000);
              const closeBtn = bundlePopup.querySelector('.bundle-popup-close');
              closeBtn.addEventListener('click', () => {
                bundlePopup.classList.remove('active');
                clearTimeout(timeout);
              });
              const handleOutsideClick = (e) => {
                if (!bundlePopup.contains(e.target)) {
                  bundlePopup.classList.remove('active');
                  clearTimeout(timeout);
                  document.removeEventListener('click', handleOutsideClick);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleOutsideClick);
              }, 0);
            }
            return;
          }
          if (hasFreezer && currentProducts.length >= 3) {
            if (bundlePopup) {
              bundlePopup.innerHTML = `
                <span>You can only add up to 3 products with a freezer bag</span>
                <button class="bundle-popup-close" aria-label="Close">&times;</button>
              `;
              bundlePopup.classList.add('active');
              const timeout = setTimeout(() => {
                bundlePopup.classList.remove('active');
              }, 5000);
              const closeBtn = bundlePopup.querySelector('.bundle-popup-close');
              closeBtn.addEventListener('click', () => {
                bundlePopup.classList.remove('active');
                clearTimeout(timeout);
              });
              const handleOutsideClick = (e) => {
                if (!bundlePopup.contains(e.target)) {
                  bundlePopup.classList.remove('active');
                  clearTimeout(timeout);
                  document.removeEventListener('click', handleOutsideClick);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleOutsideClick);
              }, 0);
            }
            return;
          }
          if (tag === 'bundle-freezer-bag' && currentProducts.length >= 3) {
            if (bundlePopup) {
              bundlePopup.innerHTML = `
                <span>You can only add up to 3 products with a freezer bag</span>
                <button class="bundle-popup-close" aria-label="Close">&times;</button>
              `;
              bundlePopup.classList.add('active');
              const timeout = setTimeout(() => {
                bundlePopup.classList.remove('active');
              }, 5000);
              const closeBtn = bundlePopup.querySelector('.bundle-popup-close');
              closeBtn.addEventListener('click', () => {
                bundlePopup.classList.remove('active');
                clearTimeout(timeout);
              });
              const handleOutsideClick = (e) => {
                if (!bundlePopup.contains(e.target)) {
                  bundlePopup.classList.remove('active');
                  clearTimeout(timeout);
                  document.removeEventListener('click', handleOutsideClick);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleOutsideClick);
              }, 0);
            }
            return;
          }
          if (hasMat && currentProducts.length >= 2) {
            if (bundlePopup) {
              bundlePopup.innerHTML = `
                <span>Only 2 products allowed when a mat is added</span>
                <button class="bundle-popup-close" aria-label="Close">&times;</button>
              `;
              bundlePopup.classList.add('active');
              const timeout = setTimeout(() => {
                bundlePopup.classList.remove('active');
              }, 5000);
              const closeBtn = bundlePopup.querySelector('.bundle-popup-close');
              closeBtn.addEventListener('click', () => {
                bundlePopup.classList.remove('active');
                clearTimeout(timeout);
              });
              const handleOutsideClick = (e) => {
                if (!bundlePopup.contains(e.target)) {
                  bundlePopup.classList.remove('active');
                  clearTimeout(timeout);
                  document.removeEventListener('click', handleOutsideClick);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleOutsideClick);
              }, 0);
            }
            return;
          }
          if (tag === 'bundle-mat' && currentProducts.length >= 2) {
            if (bundlePopup) {
              bundlePopup.innerHTML = `
                <span>Only 2 products allowed when a mat is added</span>
                <button class="bundle-popup-close" aria-label="Close">&times;</button>
              `;
              bundlePopup.classList.add('active');
              const timeout = setTimeout(() => {
                bundlePopup.classList.remove('active');
              }, 5000);
              const closeBtn = bundlePopup.querySelector('.bundle-popup-close');
              closeBtn.addEventListener('click', () => {
                bundlePopup.classList.remove('active');
                clearTimeout(timeout);
              });
              const handleOutsideClick = (e) => {
                if (!bundlePopup.contains(e.target)) {
                  bundlePopup.classList.remove('active');
                  clearTimeout(timeout);
                  document.removeEventListener('click', handleOutsideClick);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleOutsideClick);
              }, 0);
            }
            return;
          }
          if (hasTowel && currentProducts.length >= 3) {
            if (bundlePopup) {
              bundlePopup.innerHTML = `
                <span>You can only add up to 3 products with double towel</span>
                <button class="bundle-popup-close" aria-label="Close">&times;</button>
              `;
              bundlePopup.classList.add('active');
              const timeout = setTimeout(() => {
                bundlePopup.classList.remove('active');
              }, 5000);
              const closeBtn = bundlePopup.querySelector('.bundle-popup-close');
              closeBtn.addEventListener('click', () => {
                bundlePopup.classList.remove('active');
                clearTimeout(timeout);
              });
              const handleOutsideClick = (e) => {
                if (!bundlePopup.contains(e.target)) {
                  bundlePopup.classList.remove('active');
                  clearTimeout(timeout);
                  document.removeEventListener('click', handleOutsideClick);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleOutsideClick);
              }, 0);
            }
            return;
          }
          if (tag === 'bundle-double-towels' && currentProducts.length >= 3) {
            if (bundlePopup) {
              bundlePopup.innerHTML = `
                <span>You can only add up to 3 products with double towel</span>
                <button class="bundle-popup-close" aria-label="Close">&times;</button>
              `;
              bundlePopup.classList.add('active');
              const timeout = setTimeout(() => {
                bundlePopup.classList.remove('active');
              }, 5000);
              const closeBtn = bundlePopup.querySelector('.bundle-popup-close');
              closeBtn.addEventListener('click', () => {
                bundlePopup.classList.remove('active');
                clearTimeout(timeout);
              });
              const handleOutsideClick = (e) => {
                if (!bundlePopup.contains(e.target)) {
                  bundlePopup.classList.remove('active');
                  clearTimeout(timeout);
                  document.removeEventListener('click', handleOutsideClick);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleOutsideClick);
              }, 0);
            }
            return;
          }
          product.querySelector('.button__text').innerHTML =
            KROWN.settings.locales.products_added_to_bundle_label;
          const id = product.querySelector('.product-form')
            .querySelector('input[name="id"]').value;
          const variant = product.querySelector('product-variants')
            .getVariantData()
            .find(variant => variant["id"] == id);
          this.addToBundle(variant, product);
          setTimeout(() => {
            const lastItem = this.querySelector('[data-js-bundler-product]:not(.bundler-product--empty):last-child');
            if (lastItem) {
              lastItem.dataset.tag = tag;
            }
          }, 100);
          this.classList.add('opened');
          if (window.innerWidth < 768) {
            (this.querySelector('.bundler-product--empty') ||
              this.querySelector('.bundler-product:last-child'))
              ?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
          }
        });
      });

      this.querySelectorAll('[data-js-bundler-product-remove]').forEach(elm=>{
        elm.addEventListener('click', e=>{
          this.clearSlot(e.target.closest('[data-js-bundler-product]'));
        });
      });

      this.querySelector('[data-js-bundler-toggle]').addEventListener('click', e=>{
        if ( window.innerWidth < 768 ) {
          this.classList.toggle('opened');
        }
      });

      this.querySelector('[data-js-add-bundle-to-cart]').addEventListener('click', e => {
        const giftPopup = document.querySelector('.gift_box_popup');
        const savedMessage = giftPopup ? giftPopup.dataset.savedMessage : null;
        const runWithCartCheck = (afterCheck) => {
          this._updateBundlerTitle();
          afterCheck();
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => { this._syncCounterFromCart(cart); })
            .catch(() => {});
        };

        const proceedToCart = (message = null) => {
          if (!this.findEmptySlot()) {
            let items = [];
            const boxLabel = `Gift Box ${this._getGiftBoxNumber()}`;

            this.bundleProducts.map(elm => {
              if (elm.dataset.id) {
                if (!items.find(item => {
                  if (item.id == elm.dataset.id) {
                    item.quantity++;
                    return true;
                  }
                })) {
                  items.push({
                    id: elm.dataset.id,
                    quantity: 1,
                    properties: { 'Bundle': boxLabel }
                  });
                }
              }
            });

            const popupVariantId = giftPopup ? giftPopup.dataset.productId : null;

            if (popupVariantId) {
              const existingItem = items.find(item => item.id == popupVariantId);
              if (existingItem) {
                if (message) existingItem.properties = { 'Gift Message': message };
              } else {
                const newItem = { id: popupVariantId, quantity: 1 };
                if (message) newItem.properties = { 'Gift Message': message };
                items.push(newItem);
              }
            }

            if (items.length > 0) {
              const submitButton = this.querySelector('[data-js-add-bundle-to-cart]');
              submitButton.classList.add('working');

              window.handleAddToCart(
                JSON.stringify({ 'items': items }),
                items.reduce((total, { quantity }) => total + quantity, 0),
                { 'Content-Type': 'application/json' },
                () => {
                  submitButton.classList.remove('working');
                  this._incrementGiftBoxNumber();
                  this._updateBundlerTitle();
                  this.querySelectorAll('[data-js-bundler-product]').forEach(elm => {
                    this.clearSlot(elm);
                  });
                  this.classList.remove('opened');
                  if (giftPopup) delete giftPopup.dataset.savedMessage;
                }
              );
            }
          }
        };

        if (savedMessage) {
          runWithCartCheck(() => proceedToCart(savedMessage));
          return;
        }

        if (giftPopup) {
          runWithCartCheck(() => {
            giftPopup.classList.add('active');

            const oldSubmit = giftPopup.querySelector('button[type="submit"]');
            const oldClose  = giftPopup.querySelector('.close_button');
            const oldNoBtn  = giftPopup.querySelector('.no_button');
            const newSubmit = oldSubmit.cloneNode(true);
            const newClose  = oldClose.cloneNode(true);
            const newNoBtn  = oldNoBtn.cloneNode(true);
            oldSubmit.replaceWith(newSubmit);
            oldClose.replaceWith(newClose);
            oldNoBtn.replaceWith(newNoBtn);

            newSubmit.addEventListener('click', () => {
              const messageInput = giftPopup.querySelector('#gift_message');
              const message = messageInput.value.trim();
              if (!message) {
                messageInput.style.border = '2px solid red';
                messageInput.focus();
                return;
              }
              giftPopup.dataset.savedMessage = message;
              messageInput.style.border = '';
              messageInput.value = '';
              giftPopup.classList.remove('active');
            });

            newNoBtn.addEventListener('click', () => {
              giftPopup.classList.remove('active');
              proceedToCart();
            });

            newClose.addEventListener('click', () => {
              giftPopup.classList.remove('active');
            });
          });

        } else {
          runWithCartCheck(() => proceedToCart());
        }
      });

      // Variant image swap for bundle page
      this.querySelectorAll('[data-js-product-item]').forEach(productItem => {
        const variantImageData = productItem.querySelector('[data-js-bundle-variant-images]');
        if (!variantImageData) return;
        let variantImagesMap = {};
        try { variantImagesMap = JSON.parse(variantImageData.textContent); } catch(e) { return; }
        productItem.addEventListener('change', (e) => {
          if (!e.target.matches('input[name="id"]')) return;
          const selectedId = e.target.value;
          const metafieldImages = variantImagesMap[selectedId];
          if (metafieldImages && metafieldImages.length > 0) {
            this._showVariantImages(productItem, metafieldImages);
          } else {
            this._hideVariantImages(productItem);
          }
        });
      });

      // See more info popup
      document.querySelectorAll('.see_more_info').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const productId = btn.dataset.productId;
          const popup = document.getElementById(`see-more-${productId}`);
          if (popup && popup.parentNode !== document.body) {
            document.body.appendChild(popup);
          }
          if (popup) popup.classList.add('active');
        });
      });
      document.addEventListener('click', (e) => {
        if (e.target.matches('.see-more-popup__overlay') || e.target.closest('.see-more-popup__close')) {
          e.stopPropagation();
          const popup = e.target.closest('.see-more-popup');
          if (popup) popup.classList.remove('active');
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          document.querySelectorAll('.see-more-popup.active').forEach(popup => {
            popup.classList.remove('active');
          });
        }
      });
      
      
    }

    // Variant image swap for bundle page
    _showVariantImages(productItem, imageUrls) {
      const originalSlider = productItem.querySelector('[data-js-product-item-image]');
      if (originalSlider) originalSlider.style.display = 'none';
      const existing = productItem.querySelector('.bundle-variant-images');
      if (existing) {
        const existingInner = existing.querySelector('.bundle-variant-images-inner');
        if (existingInner && $(existingInner).hasClass('slick-initialized')) {
          $(existingInner).slick('destroy');
        }
        existing.remove();
      }
      const originalFigure = productItem.querySelector('.product-item__image-figure');
      const paddingTop = originalFigure ? originalFigure.style.paddingTop : '120%';
      const container = document.createElement('div');
      container.className = 'bundle-variant-images';
      container.style.cssText = 'position:relative; width:100%;';
      const inner = document.createElement('div');
      inner.className = 'bundle-variant-images-inner';
      inner.innerHTML = imageUrls.map((src, i) => `
        <div class="bundle-variant-image-slide">
          <div style="position:relative; width:100%; padding-top:${paddingTop};">
            <img
              src="${src}"
              alt=""
              loading="${i === 0 ? 'eager' : 'lazy'}"
              style="position:absolute; top:0; left:0; width:100%; height:100%; object-fit:cover;"
            />
          </div>
        </div>
      `).join('');
      container.appendChild(inner);
      const productText = productItem.querySelector('.product-item__text');
      productItem.insertBefore(container, productText);
      $(inner).slick({
        infinite: false,
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button class="bundle-slick-prev" aria-label="Previous"><svg fill="none" height="11" viewBox="0 0 6 11" width="6" xmlns="http://www.w3.org/2000/svg"><g fill="#000"><path d="m5.82422 1.08691-4.949749 4.94975-.702717-.70272 4.949746-4.949743z"></path><path d="m5.12158 10.2832-4.949745-4.94974.707107-.70711 4.949748 4.94975z"></path></g></svg></button>',
        nextArrow: '<button class="bundle-slick-next" aria-label="Next"><svg fill="none" height="11" viewBox="0 0 6 11" width="6" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(180deg)"><g fill="#000"><path d="m5.82422 1.08691-4.949749 4.94975-.702717-.70272 4.949746-4.949743z"></path><path d="m5.12158 10.2832-4.949745-4.94974.707107-.70711 4.949748 4.94975z"></path></g></svg></button>',
      });
    }

    _hideVariantImages(productItem) {
      const originalSlider = productItem.querySelector('[data-js-product-item-image]');
      if (originalSlider) originalSlider.style.display = '';
      const existing = productItem.querySelector('.bundle-variant-images');
      if (existing) {
        const existingInner = existing.querySelector('.bundle-variant-images-inner');
        if (existingInner && $(existingInner).hasClass('slick-initialized')) {
          $(existingInner).slick('destroy');
        }
        existing.remove();
      }
    }

    findEmptySlot() {
      return this.bundleProducts.find(elm=>{
        return elm.classList.contains('bundler-product--empty')
      });
    }

    clearSlot(slot) {
      if ( this.bundleProducts.length > this._bundleMin ) {
        this.bundleProducts.splice(this.bundleProducts.indexOf(slot), 1)
        slot.remove();
      } else {
        if (slot.product) {
          slot.product.classList.remove('product-item--bundled');
        }
        slot.dataset.id = "";
        slot.product = null;
        slot.classList.add('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = '';
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = '';
      }
      if ( this.findEmptySlot() ) {
        this.classList.remove('bundler-full');
      }
      this.reorderSlots();
    }

    reorderSlots() {
      let ei = 0,
          fi = -100;
      this.querySelectorAll('[data-js-bundler-product]').forEach((elm, i)=>{
        if ( elm.classList.contains('bundler-product--empty') ) {
          elm.style.order = ei++;
        } else {
          elm.style.order = fi++;
        }
      });
    }

    createSlot(){
      const newSlot = this._bundleTemplate.cloneNode(true);
      newSlot.querySelector('[data-js-bundler-product-remove]').addEventListener('click', e=>{
        this.clearSlot(e.target.closest('[data-js-bundler-product]'));
      });
      this.querySelector('[data-js-bundler-products]').appendChild(newSlot);
      this.bundleProducts.push(newSlot);
    }

    addToBundle(variant, product) {

      let slot = this.findEmptySlot();
      const imageSrc = variant.featured_image ? variant.featured_image.src : product.querySelector('[data-js-quick-buy-product-image]').textContent;

      if ( ! slot && this.hasAttribute('data-limit-maximum') ) {
        this.createSlot();
        slot = this.findEmptySlot();
      }

      if ( slot ) {

        slot.classList.remove('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = `
          <span class="bundler-product__text-title text-line-height--medium text-weight--bold">${product.querySelector('[data-js-quick-buy-product-title]').textContent}</span>
          ${ product.querySelector('product-variants').hasAttribute('data-has-variants') ? `<span class="bundler-product__text-variant text-color--opacity">${variant.title}</span>` : '' }
        `;
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = `
          <img src="${this.getResizedImageSrc(imageSrc, 60)}"
            srcset="
              ${this.getResizedImageSrc(imageSrc, 60)} 60w,
              ${this.getResizedImageSrc(imageSrc, 120)} 120w,
              ${this.getResizedImageSrc(imageSrc, 180)} 180w
            "
            sizes="60px"
          />
        `;

        if ( this.hasAttribute('data-limit-bundles') ) {
          product.classList.add('product-item--bundled');
        }
        slot.product = product;
        slot.dataset.id = product.querySelector('input[name="id"]').value;

      } else {
        // when bundle is full, show message
      }

      if ( ! this.findEmptySlot() ) {
        this.classList.add('bundler-full');
      }

    }

    getResizedImageSrc(src, size, crop='center') {
      return (`${src}${src.includes('?') ? '&' : '?'}width=${size}&height=${size}&crop=${crop}`).replace(/\n|\r|\s/g, "");
    }

  }

  if ( typeof customElements.get('product-bundler') == 'undefined' ) {
    customElements.define('product-bundler', ProductBundler);
  }

}